import type { Ticket } from "../../types";
import "./BottomSheet.scss";

interface BottomSheetProps {
  isOpen: boolean;
  selectedTickets: Ticket[];
  onConfirm: () => void;
  onCancel: () => void;
}

export const BottomSheet = ({
  isOpen,
  selectedTickets,
  onConfirm,
  onCancel,
}: BottomSheetProps) => {
  return (
    <div className={`bottom-sheet ${isOpen ? "open" : ""}`} onClick={() => {}}>
      <div className="bottom-sheet-content">
        <div className="bottom-sheet-content-left">
          <span>
            {selectedTickets.length} ticket
            {selectedTickets.length > 1 ? "s" : ""} seleccionado
            {selectedTickets.length > 1 ? "s" : ""}
          </span>
          <div className="selected-tickets">
            <div className="ticket-list">
              {selectedTickets.map((ticket) => (
                <span key={ticket.identifier} className="selected-ticket">
                  {ticket.identifier}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="actions">
          <button className="confirm" onClick={onConfirm}>
            Confirmar venta
          </button>
          {/* <button className="cancel" onClick={onCancel}>Cancelar</button> */}
        </div>
      </div>
    </div>
  );
};

